import React from "react";
import { Link, LinkProps } from "react-router-dom";

const defaultLinkStyle = "text-brand-600 hover:text-brand-800 hover:underline twoverride";

export const InternalLink: React.FC<LinkProps> = props => {
    const { className, ...rest } = props;
    return <Link className={`${defaultLinkStyle} ${className ?? ""} `} {...rest} />;
};
